<script setup lang="ts">
/**
 * UI-kit component
 * Category: Cards
 * Name: CardAdmin
 */
import type { CardAdminProps } from '../types/interfaces'

import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'CardAdmin',
})

withDefaults(defineProps<CardAdminProps>(), {
  title: '',
  subtitle: '',
  className: '',
  headerClassName: '',
  flexible: false,
  fullwidth: false,
})
</script>

<template>
  <div :class="['card-admin', { flexible }, { fullwidth }]">
    <div :class="['card-admin__head', headerClassName, { flexible }]">
      <slot
        v-if="$slots.title"
        name="title"
      />
      <div
        v-else
        class="card-admin__info"
      >
        <AppText name="h3">
          {{ title }}
        </AppText>
        <AppText
          name="body2-medium"
          color="slate-500"
        >
          {{ subtitle }}
        </AppText>
      </div>
      <slot name="header" />
    </div>
    <div :class="['card-admin__body', { flexible }, className]">
      <slot>
        No info
      </slot>
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/_card-admin.scss" />
